// TODO: dalsi hodnoty?
export enum MediaType {
    Video = "VIDEO",
}
